/** Root class for squircle corner styling (`html.cf-squircle`). Applied once at boot. */
export const K_SQUIRCLE_CLASS = "cf-squircle";

export function setSquircleEnabled(enabled: boolean): void {
  document.documentElement.classList.toggle(K_SQUIRCLE_CLASS, enabled);
}
